import { render, staticRenderFns } from "./footerContent.vue?vue&type=template&id=f277e18e&scoped=true"
import script from "./footerContent.vue?vue&type=script&lang=js"
export * from "./footerContent.vue?vue&type=script&lang=js"
import style0 from "./footerContent.vue?vue&type=style&index=0&id=f277e18e&prod&lang=less&scoped=true"
import style1 from "./footerContent.vue?vue&type=style&index=1&id=f277e18e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f277e18e",
  null
  
)

export default component.exports